/* eslint-disable */
import { loginService } from "../../_services";

const user = JSON.parse(localStorage.getItem("user"));
const state = user
  ? { status: { accessingToken: true }, user }
  : { status: {}, user: null };

const actions = {
  accessToken({ dispatch, commit }, { token, successCallback, errorCallback }) {
    commit("accessTokenRequest");

    loginService.getAccessToken(token).then(
      (user) => {
        commit("accessTokenSuccess", user);
        if(typeof successCallback === 'function') {
          successCallback();
        }
      },
      (error) => {
        commit("accessTokenFailure", error);
        dispatch("alert/error", error, { root: true });
        if (typeof errorCallback === 'function') {
          errorCallback();
        }
      }
    );
  },
  logout({ commit }) {
    loginService.logout();
    commit("logout");
  },
};

const mutations = {
  accessTokenRequest(state) {
    state.status = { accessingToken: true };
    state.user = null;
  },
  accessTokenSuccess(state, user) {
    state.status = { accessingToken: true };
    state.user = user;
  },
  accessTokenFailure(state) {
    state.status = { accessingTokenFailure: true };
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
};

